// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var AppNames;
(function (AppNames) {
    AppNames["NewNetTrader"] = "NewNetTrader";
    AppNames["Investing"] = "Investing";
    AppNames["TradingPlatform"] = "TradingPlatform";
})(AppNames || (AppNames = {}));
export var PanelNames;
(function (PanelNames) {
    PanelNames["PositionsPanel"] = "POSITIONSPANEL";
    PanelNames["OrdersPanel"] = "ORDERSPANEL";
    PanelNames["EventsPanel"] = "EVENTSPANEL";
    PanelNames["OrderHistoryPanel"] = "NAME_ORDERHISTORY_PANEL";
    PanelNames["FilledOrdersPanel"] = "NEWTRADESPANEL";
    PanelNames["AssetBalancesPanel"] = "ASSET_BALANCES_PANEL";
    PanelNames["InformerPanel"] = "INFORMERPANEL";
    PanelNames["AlertPanel"] = "ALERTPANEL";
    PanelNames["CreateAlertPanel"] = "CREATEALERTPANEL";
    PanelNames["OrderEntry"] = "NAME_ORDERCOMPOSIT_PANEL";
    PanelNames["AdvancedOrderEntry"] = "NAME_ADVANCED_ORDER_ENTRY_PANEL";
    PanelNames["ReportsPanel"] = "REPORTSPANEL";
    PanelNames["RiskCalculator"] = "RISKCALCULATOR";
    PanelNames["ProductsPanel"] = "PRODUCTSPANEL";
    PanelNames["TimeSalesPanel"] = "TRADESPANEL";
    PanelNames["AccountDetailsPanel"] = "ACCOUNTDETAILSPANEL";
    PanelNames["SymbolInfoPanel"] = "INSTRUMENTDETAILSPANEL";
    PanelNames["InstrumentHolidaysScreen"] = "INSTRUMENT_HOLIDAYS_SCREEN";
    PanelNames["MarketDepthPanel"] = "LEVEL2PANEL";
    PanelNames["ExternalScreen"] = "EXTERNALSCREEN";
    PanelNames["ChartPanel"] = "CHARTPANEL";
    PanelNames["TradingViewChartPanel"] = "TRADINGVIEW_CHARTPANEL";
    PanelNames["PortfolioTable"] = "PORTFOLIOTABLE";
    PanelNames["MarginOEControl"] = "MARGIN_OE_CONTROL";
    PanelNames["InvestingAdvancedChartPanel"] = "InvestingAdvancedChartPanel";
    PanelNames["TypesManagerScreen"] = "TYPES_MANAGER_SCREEN";
    PanelNames["GridPanel"] = "GRIDPANEL";
    PanelNames["FullLogsPanel"] = "FULLLOGSPANEL";
    PanelNames["WebAdminPanel"] = "WEBADMINPANEL";
    PanelNames["SavedOrdersPanel"] = "SAVEDORDERSPANEL";
    PanelNames["StatementPanel"] = "STATEMENTPANEL";
    PanelNames["TradingCentral"] = "TRADINGCENTRAL";
    PanelNames["IdeasPanel"] = "TRADINGIDEAS";
    PanelNames["NotificationsPanel"] = "NOTIFICATIONSPANEL";
    PanelNames["AssetsPanel"] = "ASSETSPANEL";
    PanelNames["PositionsBalancePanel"] = "POSITIONSBALANCEPANEL";
    PanelNames["NewsPanel"] = "NEWSPANEL";
    PanelNames["VideoWidget"] = "VIDEO_WIDGET";
    PanelNames["GainersLosersPanel"] = "GAINERS_LOSERS_PANEL";
    PanelNames["HighLowPanel"] = "HIGH_LOW_PANEL";
    PanelNames["ClosePositionsMutually"] = "CLOSE_POSITIONS_MUTUALLY";
    PanelNames["HeatmapPanel"] = "HEATMAP_PANEL";
    PanelNames["MamSummary"] = "MAM_SUMMARY";
    PanelNames["OptionMasterPanel"] = "OPTION_MASTER_PANEL";
    PanelNames["OptionChainPanel"] = "OPTION_CHAIN_PANEL";
    PanelNames["OptionAnalyzerPanel"] = "OPTION_ANALYZER_PANEL";
    PanelNames["OptionVolatilityLabPanel"] = "OPTION_VOLATILITY_LAB_PANEL";
    PanelNames["OptionPositionsPanel"] = "OPTION_POSITIONSPANEL";
    PanelNames["OptionOrdersPanel"] = "OPTION_ORDERSPANEL";
    PanelNames["OptionPaperPositionsPanel"] = "OPTION_PAPERPOSITIONSPANEL";
    PanelNames["NewAccountDetailsPanel"] = "NEWACCOUNTDETAILSPANEL";
    PanelNames["NewSymbolInfoPanel"] = "NEWSYMBOLINFOPANEL";
    PanelNames["CopyTradingPanel"] = "TRADING_COPY_PANEL";
    PanelNames["IndicatorsManagerPanel"] = "INDICATORS_MANAGER_PANEL";
    PanelNames["DrawingsManagerPanel"] = "DRAWINGS_MANAGER_PANEL";
    PanelNames["OverlaysManagerPanel"] = "OVERLAYS_MANAGER_PANEL";
})(PanelNames || (PanelNames = {}));
export const PanelLocKeys = {
    [PanelNames.OrderEntry]: 'panel.orderEntry',
    [PanelNames.AdvancedOrderEntry]: 'panel.orderEntry',
    [PanelNames.ChartPanel]: 'panel.chart',
    [PanelNames.InformerPanel]: 'panel.informer',
    [PanelNames.AlertPanel]: 'panel.alert',
    [PanelNames.CreateAlertPanel]: 'panel.alert',
    [PanelNames.MarketDepthPanel]: 'panel.level2',
    [PanelNames.TimeSalesPanel]: 'panel.timeSales',
    [PanelNames.PositionsPanel]: 'panel.positions',
    [PanelNames.OrdersPanel]: 'panel.orders',
    [PanelNames.OrderHistoryPanel]: 'panel.orderHistory',
    [PanelNames.FilledOrdersPanel]: 'panel.trades',
    [PanelNames.EventsPanel]: 'panel.log',
    [PanelNames.ReportsPanel]: 'ribbon.tools.reports',
    [PanelNames.ProductsPanel]: 'ribbon.tools.products',
    [PanelNames.NewAccountDetailsPanel]: 'panel.AccountDetailsPanel',
    [PanelNames.SymbolInfoPanel]: 'panel.instrumentsInfo',
    [PanelNames.AssetBalancesPanel]: 'panel.accounts',
    [PanelNames.GridPanel]: 'ribbon.tools.grid',
    [PanelNames.SavedOrdersPanel]: 'panel.savedOrders',
    [PanelNames.StatementPanel]: 'panel.statement',
    [PanelNames.FullLogsPanel]: 'ribbon.tools.full_logs',
    [PanelNames.WebAdminPanel]: 'ribbon.tools.web_admin',
    [PanelNames.AssetsPanel]: 'panel.assets',
    [PanelNames.PositionsBalancePanel]: 'panel.PositionsBalance',
    [PanelNames.NewsPanel]: 'panel.news',
    [PanelNames.RiskCalculator]: 'panel.riskCalculator',
    [PanelNames.GainersLosersPanel]: 'panel.GainersLosersPanel',
    [PanelNames.HighLowPanel]: 'panel.HighLowPanel',
    [PanelNames.ClosePositionsMutually]: 'panel.ClosePositionsMutually',
    [PanelNames.HeatmapPanel]: 'panel.HeatmapPanel',
    [PanelNames.OptionMasterPanel]: 'panel.optionMaster',
    [PanelNames.OptionChainPanel]: 'panel.optionChain',
    [PanelNames.OptionAnalyzerPanel]: 'panel.optionAnalyzer',
    [PanelNames.OptionVolatilityLabPanel]: 'panel.optionVolatilityLab',
    [PanelNames.OptionPositionsPanel]: 'panel.optionPositions',
    [PanelNames.OptionOrdersPanel]: 'panel.optionOrders',
    [PanelNames.OptionPaperPositionsPanel]: 'panel.optionPaperPositions',
    [PanelNames.NewSymbolInfoPanel]: 'panel.instrumentsInfo',
    [PanelNames.CopyTradingPanel]: 'panel.CopyTrading'
};
export var ControlsTypes;
(function (ControlsTypes) {
    ControlsTypes["CreateAlertAccountLookup"] = "CreateAlertAccountLookup";
    ControlsTypes["CreateAlertWidget"] = "CREATEALERTWIDGET";
    ControlsTypes["CreateAlertMessageSelector"] = "CREATE_ALERT_MESSAGE_SELECTOR";
    ControlsTypes["InstrumentTotalInfo"] = "INSTRUMENTTOTALINFO";
    ControlsTypes["TerceraChartToolsPanel"] = "TerceraChartToolsPanel";
    ControlsTypes["OEQuote1Viewer"] = "OEQuote1Viewer";
    ControlsTypes["OEAccountLookup"] = "OEAccountLookup";
    ControlsTypes["TerceraAccountLookup"] = "TerceraAccountLookup";
    ControlsTypes["AccountSelector"] = "AccountSelector";
    ControlsTypes["TerceraButton"] = "TerceraButton";
    ControlsTypes["TerceraLevel1Panel"] = "TERCERALEVEL1PANEL";
    ControlsTypes["TerceraTimeZoneSelector"] = "TERCERA_TIME_ZONE_SELECTOR";
    ControlsTypes["TerceraTicketViewer"] = "TERCERA_TICKET_VIEWER";
    ControlsTypes["TerceraSideBarButton"] = "TerceraSideBarButton";
    ControlsTypes["TerceraCheckBox"] = "TerceraCheckBox";
    ControlsTypes["TerceraCheckBoxEvent"] = "TerceraCheckBoxEvent";
    ControlsTypes["TerceraTextBox"] = "TerceraTextBox";
    ControlsTypes["TerceraNumeric"] = "TerceraNumeric";
    ControlsTypes["TerceraQuantityNumeric"] = "TerceraQuantityNumeric";
    ControlsTypes["OEQuantity"] = "OEQuantity";
    ControlsTypes["SLTPTriggerControl"] = "SLTPTriggerControl";
    ControlsTypes["TerceraRadioButtonComponent"] = "TerceraRadioButtonComponent";
    ControlsTypes["TerceraRadioComboItemGroup"] = "TerceraRadioComboItemGroup";
    ControlsTypes["ChartWindow"] = "ChartWindow";
    ControlsTypes["AdvancedChartOrderEntry"] = "AdvancedChartOrderEntry";
    ControlsTypes["TerceraInstrumentLookupTextBox"] = "TerceraInstrumentLookupTextBox";
    ControlsTypes["AlertsButton"] = "AlertsButton";
    ControlsTypes["IdeasButton"] = "IdeasButton";
    ControlsTypes["InvestingButton"] = "InvestingButton";
    ControlsTypes["InvestingCheckBox"] = "InvestingCheckBox";
    ControlsTypes["InvestingPasswordTextBox"] = "InvestingPasswordTextBox";
    ControlsTypes["InvestingTextBox"] = "InvestingTextBox";
    ControlsTypes["InvestingNumeric"] = "InvestingNumeric";
    ControlsTypes["InvestingQuantityNumeric"] = "InvestingQuantityNumeric";
    ControlsTypes["NotificationsButton"] = "NotificationsButton";
    ControlsTypes["VideoWidgetButton"] = "VideoWidgetButton";
    ControlsTypes["PasswordTextBox"] = "PasswordTextBox";
    ControlsTypes["PanelSideBarBase"] = "PanelSideBarBase";
    ControlsTypes["AlertItemSideBar"] = "AlertItemSideBar";
    ControlsTypes["AlertPanelSideBar"] = "AlertPanelSideBar";
    ControlsTypes["IdeasItemSideBar"] = "IdeasItemSideBar";
    ControlsTypes["IdeasPanelSideBar"] = "IdeasPanelSideBar";
    ControlsTypes["NotificationsItemSideBar"] = "NotificationsItemSideBar";
    ControlsTypes["NotificationsPanelSideBar"] = "NotificationsPanelSideBar";
    ControlsTypes["VideoWidgetItemSideBar"] = "VideoWidgetItemSideBar";
    ControlsTypes["VideoWidgetPanelSideBar"] = "VideoWidgetPanelSideBar";
    ControlsTypes["NewAccountDetailsPanel"] = "NewAccountDetailsPanel";
    ControlsTypes["NewAccountDetailsGroup"] = "NewAccountDetailsGroup";
    ControlsTypes["NewAccountDetailsItem"] = "NewAccountDetailsItem";
    ControlsTypes["DPSLTPControl"] = "DPSLTPControl";
    ControlsTypes["TradingViewOrderTool"] = "TradingViewOrderTool";
    ControlsTypes["VerticalDetailsGroup"] = "VerticalDetailsGroup";
    ControlsTypes["VerticalDetailsItem"] = "VerticalDetailsItem";
    ControlsTypes["OEComment"] = "OEComment";
    ControlsTypes["TerceraSeparator"] = "TerceraSeparator";
    ControlsTypes["TerceraPanel"] = "TerceraPanel";
    ControlsTypes["TerceraAutoHidePanel"] = "TerceraAutoHidePanel";
    ControlsTypes["DynPropertyControl"] = "DynPropertyControl";
    ControlsTypes["DPTradingNumeric"] = "DPTradingNumeric";
    ControlsTypes["TerceraVisualTradingWidget"] = "TerceraVisualTradingWidget";
    ControlsTypes["GoogleAuthenticator"] = "GoogleAuthenticator";
    ControlsTypes["TerceraLinkControl"] = "TerceraLinkControl";
    ControlsTypes["TerceraLinkLabel"] = "TerceraLinkLabel";
    ControlsTypes["LinkLabelContainer"] = "LinkLabelContainer";
    ControlsTypes["StepProgressBar"] = "StepProgressBar";
    ControlsTypes["TerceraDatePickerCalendarComponent"] = "TerceraDatePickerCalendarComponent";
    ControlsTypes["TerceraDateRangeDropDownForm"] = "TerceraDateRangeDropDownForm";
    ControlsTypes["TerceraDatePickerDropDown"] = "TerceraDatePickerDropDown";
    ControlsTypes["TerceraDateTimePicker"] = "TerceraDateTimePicker";
    ControlsTypes["TerceraDateRangeLookup"] = "TerceraDateRangeLookup";
    ControlsTypes["OETIFSelector"] = "OETIFSelector";
    ControlsTypes["TerceraWidthComboBox"] = "TerceraWidthComboBox";
    ControlsTypes["TerceraLineStyleComboBox"] = "TerceraLineStyleComboBox";
    ControlsTypes["TradingButtonStripe"] = "TradingButtonStripe";
    ControlsTypes["WatchlistComboBox"] = "WatchlistComboBox";
})(ControlsTypes || (ControlsTypes = {}));
export var ScreensNames;
(function (ScreensNames) {
    // TODO. Remove.
    // InvestingMessageBox = 'InvestingMessageBox',
    ScreensNames["InvestingForgotPasswordScreen"] = "InvestingForgotPasswordScreen";
    ScreensNames["InvestingChangePasswordScreen"] = "InvestingChangePasswordScreen";
    ScreensNames["InvestingMessageBox"] = "InvestingMessageBox";
    ScreensNames["TerceraMessageBox"] = "TerceraMessageBox";
    ScreensNames["AlertMessageBox"] = "AlertMessageBox";
    ScreensNames["TerceraLoginScreen"] = "TerceraLoginScreen";
    ScreensNames["InvestingLoginScreen"] = "InvestingLoginScreen";
    ScreensNames["ModifyScreen"] = "MODIFYSCREEN";
    ScreensNames["EditPositionScreen"] = "EDITPOSITIONSCREEN";
    ScreensNames["ClosePositionScreen"] = "CLOSEPOSITIONSCREEN";
    ScreensNames["ModifyPositionScreen"] = "MODIFYPOSITIONSCREEN";
    ScreensNames["ModifyOrderScreen"] = "MODIFYORDERSCREEN";
    ScreensNames["PositionExerciseRequestScreen"] = "POSITIONEXERCISEREQUESTSCREEN";
    ScreensNames["BrokerMessageScreen"] = "BROKERMESSAGESCREEN";
    ScreensNames["WithdrawalScreen"] = "WITHDRAWALSCREEN";
    ScreensNames["PopupErrorScreen"] = "PopupErrorScreen";
    ScreensNames["SnapshotScreen"] = "SnapshotScreen";
    ScreensNames["ConfirmationScreen"] = "ConfirmationScreen";
    ScreensNames["ObjectManagerScreen"] = "ObjectManagerScreen";
    ScreensNames["RenameScreen"] = "RenameScreen";
    ScreensNames["AddOverlayScreen"] = "AddOverlayScreen";
    ScreensNames["TerceraLookupDropDownForm"] = "TerceraLookupDropDownForm";
    ScreensNames["TerceraInstrumentLookupDropDownForm"] = "TerceraInstrumentLookupDropDownForm";
    ScreensNames["WebhooksScreen"] = "WebhooksScreen";
    ScreensNames["WebhookCreatedScreen"] = "WebhookCreatedScreen";
})(ScreensNames || (ScreensNames = {}));
export const PanelsWithAccountLookup = [
    PanelNames.NewAccountDetailsPanel,
    PanelNames.AdvancedOrderEntry,
    PanelNames.AssetsPanel,
    PanelNames.ChartPanel,
    PanelNames.CreateAlertPanel,
    PanelNames.IdeasPanel,
    PanelNames.MarketDepthPanel,
    PanelNames.MarginOEControl,
    PanelNames.PositionsBalancePanel,
    PanelNames.ReportsPanel,
    PanelNames.RiskCalculator,
    ScreensNames.WithdrawalScreen
];
